import { useEffect } from "react";
import { createContext, useReducer, useState } from "react";




export const Userauthcontext = createContext() // for User


export const Userauthreducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN':
            return { user: action.payload }
        case 'LOGOUT':
            return { user: null }
        default:
            return state;
    }
}



export const UserAuthContextProvider = ({ children }) => {

    const [state, dispatch] = useReducer(Userauthreducer, {
        user: null,
    })
    const [Authloading, setLoading] = useState(true); // Add a loading state

    useEffect(() => {
        // Safely parse the user data
        const userData = localStorage.getItem('user');
        // const sessionTime = localStorage.getItem('expiryTime');
        // if (userData) {
        //     dispatch({ type: 'LOGIN', payload: userData });
        // }
        if (userData) {
            try {
                const parsedUser = userData;
                dispatch({ type: "LOGIN", payload: parsedUser });
            } catch (error) {
                console.error("Failed to parse user data from localStorage:", error);
            }
        }
        setLoading(false); // Finish initialization
    }, [])

    //console.log('AuthContext State: ', state);

    return (
        <Userauthcontext.Provider value={{ ...state, dispatch, Authloading}}>
            {children}
        </Userauthcontext.Provider>
    )
}